import Amount from "@/models/Shared/Amount";

export default class TransactionalFee {
    id: string = '';
    name: string = '';
    reference: string = '';
    transactionType: string = '';
    subTransactionType: string = '';
    fixedAmount: Amount = new Amount();
    percentage: number = 0;
    includeAmountInPercentage: boolean = false;
}